import type { FC, ReactNode } from "react";

export interface SearchModalEmptyState {
  title: string;
  description?: string;
  icon?: ReactNode;
}

export interface SearchModalCenteredStateProps {
  state: SearchModalEmptyState;
}

/** Quiet, centered placeholder — deliberately understated, never a call to action. */
export const SearchModalCenteredState: FC<SearchModalCenteredStateProps> = (
  props,
) => {
  const { state } = props;

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-2 px-6 py-8 text-center text-muted-foreground">
      {state.icon ? <span className="shrink-0">{state.icon}</span> : null}
      <p className="text-sm leading-5">{state.title}</p>
      {state.description ? (
        <p className="max-w-sm text-xs leading-4">{state.description}</p>
      ) : null}
    </div>
  );
};
